import { oldEventRecords as eventRecords } from './analytics.old';

export const DashboardEvents = {
    loadedDashboard: eventRecords.DashboardEventsLoadedDashboard.eventName,
    clickDocuments: eventRecords.DashboardEventsClickDocuments.eventName,
    clickActions: eventRecords.DashboardEventsClickActions.eventName,
    clickTransaction: eventRecords.DashboardEventsClickTransaction.eventName,
    downloadDocumentsMenu: eventRecords.DashboardEventsDownloadDocumentsMenu.eventName,
    loadTransactionDetails: eventRecords.DashboardEventsLoadTransactionDetails.eventName,
    clickShowNumber: eventRecords.DashboardEventsClickShowNumber.eventName,
    clickHideNumber: eventRecords.DashboardEventsClickHideNumber.eventName,
    clickShowCardModal: eventRecords.DashboardEventsClickShowCardModal.eventName,
    authFormLoaded: eventRecords.DashboardEventsAuthFormLoaded.eventName,
    authCodeSubmitted: eventRecords.DashboardEventsAuthCodeSubmitted.eventName,
    authSubmitted: eventRecords.DashboardEventsAuthSubmitted.eventName,
    authModalClose: eventRecords.DashboardEventsAuthModalClose.eventName,
    transactionSelectCategory: eventRecords.DashboardEventsTransactionSelectCategory.eventName,
    transactionSelectProject: eventRecords.DashboardEventsTransactionSelectProject.eventName,
    openExpenseProject: eventRecords.DashboardEventsOpenExpenseProject.eventName,
    txFeedEmptyStateOrderCardClick: eventRecords.DashboardEventsTxFeedEmptyStateOrderCardClick.eventName
};

export const SetupListEvents = {
    listLoaded: eventRecords.SetupListEventsListLoaded.eventName,
    clickCollapseExpand: eventRecords.SetupListEventsClickCollapseExpand.eventName,
    clickListItem: eventRecords.SetupListEventsClickListItem.eventName,
    clickHide: eventRecords.SetupListEventsClickHide.eventName
};

export const CardModalEvents = {
    clickCopyButton: eventRecords.CardModalEventsClickCopyButton.eventName,
    modalClose: eventRecords.CardModalEventsModalClose.eventName,
    clickFreezeCard: eventRecords.CardModalEventsClickFreezeCard.eventName,
    clickUnfreezeCard: eventRecords.CardModalEventsClickUnfreezeCard.eventName,
    bannerShown: eventRecords.CardModalEventsBannerShown.eventName,
    updatePaymentMethod: eventRecords.CardModalEventsUpdatePaymentMethod.eventName
};

export const CancelCardModalEvents = {
    modalLoaded: eventRecords.CancelCardModalEventsModalLoaded.eventName,
    modalClosed: eventRecords.CancelCardModalEventsModalClosed.eventName,
    clickCancelCard: eventRecords.CancelCardModalEventsClickCancelCard.eventName
};

export const CreateCardModalEvents = {
    modalLoaded: eventRecords.CreateCardModalEventsModalLoaded.eventName,
    modalClosed: eventRecords.CreateCardModalEventsModalClosed.eventName,
    createCard: eventRecords.CreateCardModalEventsCreateCard.eventName
};

export const ActivateCardEvents = {
    clickActivateCard: eventRecords.ActivateCardEventsClickActivateCard.eventName,
    successActivateCard: eventRecords.ActivateCardEventsSuccessActivateCard.eventName,
    errorActivateCard: eventRecords.ActivateCardEventsErrorActivateCard.eventName
};

export const DocumentsEvents = {
    loadModal: eventRecords.DocumentsEventsLoadModal.eventName,
    clickDownload: eventRecords.DocumentsEventsClickDownload.eventName,
    clickPreview: eventRecords.DocumentsEventsClickPreview.eventName
};

export const SmartTaxEvents = {
    clickLoadModal: eventRecords.SmartTaxEventsClickLoadModal.eventName,
    loadedModal: eventRecords.SmartTaxEventsLoadedModal.eventName,
    clickCloseModal: eventRecords.SmartTaxEventsClickCloseModal.eventName,
    clickEditCalculationField: eventRecords.SmartTaxEventsClickEditCalculationField.eventName,
    clickCalculate: eventRecords.SmartTaxEventsClickCalculate.eventName
};

export const ExpenseTaggingEvent = {
    loadedMain: eventRecords.ExpenseTaggingEventLoadedMain.eventName,
    clickSelectCategoryCTA: eventRecords.ExpenseTaggingEventClickSelectCategoryCTA.eventName,
    loadedCategoryPicker: eventRecords.ExpenseTaggingEventLoadedCategoryPicker.eventName,
    clickCategorySelected: eventRecords.ExpenseTaggingEventClickCategorySelected.eventName,
    clickSeeMore: eventRecords.ExpenseTaggingEventClickSeeMore.eventName,
    clickEditCategory: eventRecords.ExpenseTaggingEventClickEditCategory.eventName,
    clickSaveCTA: eventRecords.ExpenseTaggingEventClickSaveCTA.eventName,
    loadedSummary: eventRecords.ExpenseTaggingEventLoadedSummary.eventName,
    clickDoneCTA: eventRecords.ExpenseTaggingEventClickDoneCTA.eventName,
    clickHelpCenter: eventRecords.ExpenseTaggingEventClickHelpCenter.eventName,
    clickEmptyExpenseWidgetPreview: eventRecords.ExpenseTaggingEventClickEmptyExpenseWidgetPreview.eventName
};

export const TransferMoneyEvents = {
    clickTransferMoney: eventRecords.TransferMoneyEventsClickTransferMoney.eventName,
    loadModal: eventRecords.TransferMoneyEventsLoadModal.eventName,
    clickCloseModal: eventRecords.TransferMoneyEventsClickCloseModal.eventName,
    clickConfirmTransferMoney: eventRecords.TransferMoneyEventsClickConfirmTransferMoney.eventName,
    clickSubmitTransferMoney: eventRecords.TransferMoneyEventsClickSubmitTransferMoney.eventName,
    startNewRecurringTransfer: eventRecords.TransferMoneyEventsStartNewRecurringTransfer.eventName,
    toggleRecurringTransferStatus: eventRecords.TransferMoneyEventsToggleRecurringTransferStatus.eventName,
    closeRecurringModal: eventRecords.TransferMoneyEventsCloseRecurringModal.eventName,
    confirmCreateRecipient: eventRecords.TransferMoneyEventsConfirmCreateRecipient.eventName,
    learnMoreRecurringTransfers: eventRecords.TransferMoneyEventsLearnMoreRecurringTransfers.eventName
};

export const TaxWithholdingEvents = {
    clickStartTaxWithholding: eventRecords.TaxWithholdingEventsClickStartTaxWithholding.eventName,
    loadModal: eventRecords.TaxWithholdingEventsLoadModal.eventName,
    closeModal: eventRecords.TaxWithholdingEventsCloseModal.eventName,
    clickOptIn: eventRecords.TaxWithholdingEventsClickOptIn.eventName,
    successOptIn: eventRecords.TaxWithholdingEventsSuccessOptIn.eventName,
    clickActions: eventRecords.TaxWithholdingEventsClickActions.eventName,
    clickOptOut: eventRecords.TaxWithholdingEventsClickOptOut.eventName,
    loadOptOutModal: eventRecords.TaxWithholdingEventsLoadOptOutModal.eventName,
    clickConfirmOptOut: eventRecords.TaxWithholdingEventsClickConfirmOptOut.eventName,
    clickDiscardOptOut: eventRecords.TaxWithholdingEventsClickDiscardOptOut.eventName,
    successOptOut: eventRecords.TaxWithholdingEventsSuccessOptOut.eventName,
    clickWithdraw: eventRecords.TaxWithholdingEventsClickWithdraw.eventName,
    loadWithdrawModal: eventRecords.TaxWithholdingEventsLoadWithdrawModal.eventName,
    clickConfirmWithdraw: eventRecords.TaxWithholdingEventsClickConfirmWithdraw.eventName,
    clickDiscardWithdraw: eventRecords.TaxWithholdingEventsClickDiscardWithdraw.eventName,
    successWithdraw: eventRecords.TaxWithholdingEventsSuccessWithdraw.eventName
};

export const TransferMoneyEventsWithRecipient = {
    loadSelectRecipient: eventRecords.TransferMoneyEventsWithRecipientLoadSelectRecipient.eventName,
    recipientDetails: eventRecords.TransferMoneyEventsWithRecipientRecipientDetails.eventName,
    loadRecipientDetails: eventRecords.TransferMoneyEventsWithRecipientLoadRecipientDetails.eventName,
    successRecipientDetails: eventRecords.TransferMoneyEventsWithRecipientSuccessRecipientDetails.eventName,
    errorRecipientDetails: eventRecords.TransferMoneyEventsWithRecipientErrorRecipientDetails.eventName,
    clickAddRecipientDropdown: eventRecords.TransferMoneyEventsWithRecipientClickAddRecipientDropdown.eventName,
    clickBackStep: eventRecords.TransferMoneyEventsWithRecipientClickBackStep.eventName,
    clickNextStep: eventRecords.TransferMoneyEventsWithRecipientClickNextStep.eventName,
    closeModal: eventRecords.TransferMoneyEventsWithRecipientCloseModal.eventName,
    successTransferMoney: eventRecords.TransferMoneyEventsWithRecipientSuccessTransferMoney.eventName,
    errorTransferMoney: eventRecords.TransferMoneyEventsWithRecipientErrorTransferMoney.eventName,
    useCardBannerLoad: eventRecords.TransferMoneyEventsWithRecipientUseCardBannerLoad.eventName,
    useCardBannerLinkClick: eventRecords.TransferMoneyEventsWithRecipientUseCardBannerLinkClick.eventName
};

export const KYCEvents = {
    pageLoaded: eventRecords.KYCEventsPageLoaded.eventName,
    backClick: eventRecords.KYCEventsBackClick.eventName,
    closeClick: eventRecords.KYCEventsCloseClick.eventName,
    nextClick: eventRecords.KYCEventsNextClick.eventName,
    beneficialOwnerAdded: eventRecords.KYCEventsBeneficialOwnerAdded.eventName,
    beneficialOwnerRemoved: eventRecords.KYCEventsBeneficialOwnerRemoved.eventName,
    beneficialOwnerRemoveConfirm: eventRecords.KYCEventsBeneficialOwnerRemoveConfirm.eventName,
    businessCheckbox: eventRecords.KYCEventsBusinessCheckbox.eventName,
    formSubmitted: eventRecords.KYCEventsFormSubmitted.eventName,
    agreementCheckbox: eventRecords.KYCEventsAgreementCheckbox.eventName,
    completed: eventRecords.KYCEventsCompleted.eventName,
    error: eventRecords.KYCEventsError.eventName,
    kyc: eventRecords.KYCEventsKyc.eventName,
    beneficialOwnerNeeded: eventRecords.KYCEventsBeneficialOwnerNeeded.eventName,
    entityTypeSelected: eventRecords.KYCEventsEntityTypeSelected.eventName
};

export const ApplicationEvents = {
    pageLoaded: eventRecords.ApplicationEventsPageLoaded.eventName,
    attachmentClick: eventRecords.ApplicationEventsAttachmentClick.eventName,
    submitDocuments: eventRecords.ApplicationEventsSubmitDocuments.eventName,
    uploadSuccess: eventRecords.ApplicationEventsUploadSuccess.eventName,
    uploadError: eventRecords.ApplicationEventsUploadError.eventName,
    invalidFileSize: eventRecords.ApplicationEventsInvalidFileSize.eventName
};

export const WelcomeEvents = {
    pageLoaded: eventRecords.WelcomeEventsPageLoaded.eventName,
    clickCTA: eventRecords.WelcomeEventsClickCTA.eventName,
    faqClick: eventRecords.WelcomeEventsFaqClick.eventName,
    paymentSplitsEngaged: eventRecords.WelcomeEventsPaymentSplitsEngaged.eventName,
    paymentSplitsAmountSet: eventRecords.WelcomeEventsPaymentSplitsAmountSet.eventName
};

export const SavingPercentageBucketEvents = {
    modalLoaded: eventRecords.SavingPercentageBucketEventsModalLoaded.eventName,
    confirmClick: eventRecords.SavingPercentageBucketEventsConfirmClick.eventName,
    closeClick: eventRecords.SavingPercentageBucketEventsCloseClick.eventName
};

export const ManualTransferBucketEvents = {
    modalLoaded: eventRecords.ManualTransferBucketEventsModalLoaded.eventName,
    confirmClick: eventRecords.ManualTransferBucketEventsConfirmClick.eventName,
    closeClick: eventRecords.ManualTransferBucketEventsCloseClick.eventName,
    success: eventRecords.ManualTransferBucketEventsSuccess.eventName,
    error: eventRecords.ManualTransferBucketEventsError.eventName
};

export const CreateSavingsBucketEvents = {
    modalLoaded: eventRecords.CreateSavingsBucketEventsModalLoaded.eventName,
    confirmClick: eventRecords.CreateSavingsBucketEventsConfirmClick.eventName,
    closeClick: eventRecords.CreateSavingsBucketEventsCloseClick.eventName,
    success: eventRecords.CreateSavingsBucketEventsSuccess.eventName,
    error: eventRecords.CreateSavingsBucketEventsError.eventName
};

export const EditSavingsBucketEvents = {
    modalLoaded: eventRecords.EditSavingsBucketEventsModalLoaded.eventName,
    confirmClick: eventRecords.EditSavingsBucketEventsConfirmClick.eventName,
    closeClick: eventRecords.EditSavingsBucketEventsCloseClick.eventName,
    success: eventRecords.EditSavingsBucketEventsSuccess.eventName,
    error: eventRecords.EditSavingsBucketEventsError.eventName
};

export const DeleteSavingsBucketEvents = {
    modalLoaded: eventRecords.DeleteSavingsBucketEventsModalLoaded.eventName,
    confirmClick: eventRecords.DeleteSavingsBucketEventsConfirmClick.eventName,
    closeClick: eventRecords.DeleteSavingsBucketEventsCloseClick.eventName,
    success: eventRecords.DeleteSavingsBucketEventsSuccess.eventName,
    error: eventRecords.DeleteSavingsBucketEventsError.eventName
};

export const SavingsBucketEvents = {
    actionClick: eventRecords.SavingsBucketEventsActionClick.eventName
};

export const FreezeSavingsBucketEvents = {
    modalLoaded: eventRecords.FreezeSavingsBucketEventsModalLoaded.eventName,
    confirmClick: eventRecords.FreezeSavingsBucketEventsConfirmClick.eventName,
    closeClick: eventRecords.FreezeSavingsBucketEventsCloseClick.eventName,
    success: eventRecords.FreezeSavingsBucketEventsSuccess.eventName,
    error: eventRecords.FreezeSavingsBucketEventsError.eventName
};

export const WithdrawBucketSavingsEvents = {
    modalLoaded: eventRecords.WithdrawBucketSavingsEventsModalLoaded.eventName,
    confirmClick: eventRecords.WithdrawBucketSavingsEventsConfirmClick.eventName,
    closeClick: eventRecords.WithdrawBucketSavingsEventsCloseClick.eventName,
    success: eventRecords.WithdrawBucketSavingsEventsSuccess.eventName,
    error: eventRecords.WithdrawBucketSavingsEventsError.eventName
};

export const ProductTourEvents = {
    tourStarted: eventRecords.ProductTourEventsTourStarted.eventName
};

export const CashflowInsightEvents = {
    balanceDetailsClick: eventRecords.CashflowInsightEventsBalanceDetailsClick.eventName,
    modalLoaded: eventRecords.CashflowInsightEventsModalLoaded.eventName,
    modalClosed: eventRecords.CashflowInsightEventsModalClosed.eventName,
    timeframeDropdown: eventRecords.CashflowInsightEventsTimeframeDropdown.eventName,
    timeframeDropdownSelect: eventRecords.CashflowInsightEventsTimeframeDropdownSelect.eventName
};

export const OverviewEvents = {
    loaded: eventRecords.OverviewEventsLoaded.eventName,
    taxesCTAClick: eventRecords.OverviewEventsTaxesCTAClick.eventName,
    cardCTAClick: eventRecords.OverviewEventsCardCTAClick.eventName
};

export const HBPaymentsWidgetEvents = {
    paymentsLink: eventRecords.HBPaymentsWidgetEventsPaymentsLink.eventName
};

export const HBPaymentsSnapshotEvents = {
    paymentsLink: eventRecords.HBPaymentsSnapshotEventsPaymentsLink.eventName
};

export const OverviewFeaturePromoBannerEvents = {
    moreInfoLink: eventRecords.OverviewFeaturePromoBannerEventsMoreInfoLink.eventName,
    closeBanner: eventRecords.OverviewFeaturePromoBannerEventsCloseBanner.eventName
};

export const OverviewPromoteBalanceEvents = {
    learnMore: eventRecords.OverviewPromoteBalanceEventsLearnMore.eventName,
    applyNow: eventRecords.OverviewPromoteBalanceEventsApplyNow.eventName,
    videoImage: eventRecords.OverviewPromoteBalanceEventsVideoImage.eventName,
    videoModal: eventRecords.OverviewPromoteBalanceEventsVideoModal.eventName,
    watchedVideo: eventRecords.OverviewPromoteBalanceEventsWatchedVideo.eventName,
    closeVideoModal: eventRecords.OverviewPromoteBalanceEventsCloseVideoModal.eventName
};

export const PlaidEvents = {
    connectAccount: eventRecords.PlaidEventsConnectAccount.eventName,
    success: eventRecords.PlaidEventsSuccess.eventName,
    reconnect: eventRecords.PlaidEventsReconnect.eventName,
    exchangePublicTokenError: eventRecords.PlaidEventsExchangePublicTokenError.eventName,
    linkTokenError: eventRecords.PlaidEventsLinkTokenError.eventName,
    close: eventRecords.PlaidEventsClose.eventName
};

export const ExternalAccountsMenuEvents = {
    open: eventRecords.ExternalAccountsMenuEventsOpen.eventName,
    rename: eventRecords.ExternalAccountsMenuEventsRename.eventName,
    delete: eventRecords.ExternalAccountsMenuEventsDelete.eventName,
    deleteModal: eventRecords.ExternalAccountsMenuEventsDeleteModal.eventName,
    viewDetails: eventRecords.ExternalAccountsMenuEventsViewDetails.eventName,
    loadDetailsModal: eventRecords.ExternalAccountsMenuEventsLoadDetailsModal.eventName,
    detailsModalChangeTimeframe: eventRecords.ExternalAccountsMenuEventsDetailsModalChangeTimeframe.eventName
};

export const ExternalAccountsPopoverEvents = {
    open: eventRecords.ExternalAccountsPopoverEventsOpen.eventName,
    dismiss: eventRecords.ExternalAccountsPopoverEventsDismiss.eventName,
    connectAccount: eventRecords.ExternalAccountsPopoverEventsConnectAccount.eventName
};

export const ExternalInstitutionDeleteModalEvents = {
    modalLoaded: eventRecords.ExternalInstitutionDeleteModalEventsModalLoaded.eventName,
    confirm: eventRecords.ExternalInstitutionDeleteModalEventsConfirm.eventName,
    close: eventRecords.ExternalInstitutionDeleteModalEventsClose.eventName,
    success: eventRecords.ExternalInstitutionDeleteModalEventsSuccess.eventName,
    error: eventRecords.ExternalInstitutionDeleteModalEventsError.eventName
};

export const WhitelistEvents = {
    pageLoaded: eventRecords.WhitelistEventsPageLoaded.eventName,
    whiteListCTAClick: eventRecords.WhitelistEventsWhiteListCTAClick.eventName,
    videoClick: eventRecords.WhitelistEventsVideoClick.eventName
};

export const MWebEvents = {
    overviewPage: eventRecords.MWebEventsOverviewPage.eventName,
    kycPage: eventRecords.MWebEventsKycPage.eventName,
    dashboardPage: eventRecords.MWebEventsDashboardPage.eventName,
    openApp: eventRecords.MWebEventsOpenApp.eventName,
    overviewLearnMore: eventRecords.MWebEventsOverviewLearnMore.eventName,
    balanceFAQ: eventRecords.MWebEventsBalanceFAQ.eventName
};

export const YearlyRevenueGoalEvents = {
    loadWidget: eventRecords.YearlyRevenueGoalEventsLoadWidget.eventName,
    clickNewGoalCta: eventRecords.YearlyRevenueGoalEventsClickNewGoalCta.eventName,
    loadSetGoalModal: eventRecords.YearlyRevenueGoalEventsLoadSetGoalModal.eventName,
    submitGoal: eventRecords.YearlyRevenueGoalEventsSubmitGoal.eventName,
    closeSetGoalModal: eventRecords.YearlyRevenueGoalEventsCloseSetGoalModal.eventName,
    clickMenuEditGoal: eventRecords.YearlyRevenueGoalEventsClickMenuEditGoal.eventName,
    clickMenuDeleteGoal: eventRecords.YearlyRevenueGoalEventsClickMenuDeleteGoal.eventName,
    loadReachedGoalModal: eventRecords.YearlyRevenueGoalEventsLoadReachedGoalModal.eventName,
    clickReachedGoalModalCTA: eventRecords.YearlyRevenueGoalEventsClickReachedGoalModalCTA.eventName,
    clickReachedGoalBannerCTA: eventRecords.YearlyRevenueGoalEventsClickReachedGoalBannerCTA.eventName,
    loadDeleteGoalModal: eventRecords.YearlyRevenueGoalEventsLoadDeleteGoalModal.eventName,
    clickCloseDeleteGoalModal: eventRecords.YearlyRevenueGoalEventsClickCloseDeleteGoalModal.eventName,
    clickDeleteGoalCTA: eventRecords.YearlyRevenueGoalEventsClickDeleteGoalCTA.eventName,
    popoverLoad: eventRecords.YearlyRevenueGoalEventsPopoverLoad.eventName,
    popoverClose: eventRecords.YearlyRevenueGoalEventsPopoverClose.eventName,
    goalAchievedToastShown: eventRecords.YearlyRevenueGoalEventsGoalAchievedToastShown.eventName,
    goalAchievedToastCTA: eventRecords.YearlyRevenueGoalEventsGoalAchievedToastCTA.eventName,
    goalAchievedToastDismissed: eventRecords.YearlyRevenueGoalEventsGoalAchievedToastDismissed.eventName
};

export const TaxCategorization = {
    tourLoaded: eventRecords.TaxCategorizationTourLoaded.eventName,
    tourClose: eventRecords.TaxCategorizationTourClose.eventName,
    tourNextClick: eventRecords.TaxCategorizationTourNextClick.eventName
};
